import {
  IAddFamilyMemberRequest,
  IAddFamilyMemberResponse,
  ISearchChatRequest,
  ISearchChatResponse,
} from "@/models/ApiRequestResponse/chat";
import { GBSCError } from "@/models/GBSCError";

import { patch, post, get } from "@/utils/TypedApi";

import {
  APIEndpoint,
  IAPIStatusCode,
  IAPIStatusType,
  messages,
} from "../APIEndpointConfig";

export const fetchUserDetails = async ({
  user_ids = [],
  doctor_ids = [],
  ip_dash_id = [],
  device_token_user_id = "",
  appointment_ids = [],
  member_ids = [],
}: Record<string, any>) => {
  try {
    const response = await post<any>(APIEndpoint.patient.fetchUserDetails, {
      user_ids,
      doctor_ids,
      ip_dash_id,
      device_token_user_id,
      appointment_ids,
      member_ids,
    });

    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }

    const { errorMessage, message, statusCode } = response;

    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
};

export const addFamilyMemberApi = async (
  requestBody: IAddFamilyMemberRequest
): Promise<IAddFamilyMemberResponse | GBSCError> => {
  try {
    const response = await patch<IAddFamilyMemberResponse>(
      APIEndpoint.doctor.addFamilyMember,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const searchChatByName = async (
  params: ISearchChatRequest
): Promise<ISearchChatResponse | GBSCError> => {
  try {
    const queryParams = {
      search: params.search,
      type: params.type,
      limit: String(params.limit),
      offset: String(params.offset),
    };

    if (params.doctor_id) {
      queryParams["doctor_id"] = params.doctor_id;
    }

    const queryString = new URLSearchParams(queryParams).toString();

    const url = `${APIEndpoint.doctor.searchChat}?${queryString}`;
    const response = await get<ISearchChatResponse>(url);

    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
    return new GBSCError(
      IAPIStatusType.ERROR,
      messages.somethingWentWrong,
      IAPIStatusCode.INTERNAL_SERVER_ERROR
    );
  }
};
